import React, { lazy, Suspense, useEffect, useState } from "react";
import { Link, NavLink, Route, Routes, useLocation } from "react-router-dom";
import Homepage from "./pages/HomePage";
import TsagUyPage from "./pages/TsagUyPage";
import ChapterListPage from "./pages/ChapterListPage";
import BookListPage from "./pages/BookListPage";
import AppInfo, { APP_INFO } from "./components/AppInfo";
import Icon from "./components/Icon";
import LoadingPage from "./components/LoadingPage";
import logo from "./img/logo1.png";
import "./index.css";

const EshleluudPage = lazy(() => import("./pages/EshleluudPage"));
const DuruudPage = lazy(() => import("./pages/DuruudPage"));
const NomuudPage = lazy(() => import("./pages/NomuudPage"));
const KingsPeriodExercise = lazy(
  () => import("./components/KingsPeriodExercise"),
);
const EshUzuulegchidExercise = lazy(
  () => import("./components/EshUzuulegchidExercise"),
);
const PersonOrPlaceExercise = lazy(
  () => import("./components/PersonOrPlacesExercise"),
);
const BibleCharacters = lazy(() => import("./pages/BibleduruudPage"));
const CrosswordExercise = lazy(() => import("./components/CrosswordExercise"));

const routeInfo = (path) => {
  if (path.startsWith("/eshleluud/"))
    return { parent: "/eshleluud", label: "📖 Илчлэлтийн 22 бүлэг" };
  if (path.startsWith("/duruud/"))
    return { parent: "/duruud", label: "📖 Илчлэлтийн 3 дүр" };
  if (path.startsWith("/buleg-taah/"))
    return { parent: "/buleg-taah", label: "Зургаар бүлэг таах" };
  if (path.startsWith("/tsag-uy/"))
    return { parent: "/tsag-uy", label: "Цаг үеүүд" };
  return { parent: "/", label: "Нүүр хуудас" };
};

function SiteHeader({ onInfo }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setMenuOpen(false), [location.pathname]);
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-brand" aria-label="МСС дасгал ажил">
          <span className="site-brand__mark">
            <Icon name="book" size={24} />
          </span>
          <span className="site-brand__copy">
            <strong>МСС дасгал ажил</strong>
          </span>
        </Link>
        <nav
          className={`site-nav ${menuOpen ? "site-nav--open" : ""}`}
          id="site-navigation"
          aria-label="МСС дасгал ажил"
        >
          <NavLink to="/" end>
            <Icon name="home" size={17} />
            Нүүр хуудас
          </NavLink>
          <NavLink to="/tsag-uy">
            <Icon name="clock" size={17} />
            Цаг үеүүд
          </NavLink>
          <NavLink to="/bibleduruud">
            <Icon name="people" size={17} />
            Библийн дүрүүд
          </NavLink>
          <button
            className="site-nav__info"
            type="button"
            onClick={() => {
              setMenuOpen(false);
              onInfo();
            }}
          >
            <Icon name="info" size={17} />
            {APP_INFO.title}
          </button>
        </nav>
        <div className="site-header__right">
          <img className="brand-wordmark" src={logo} alt="MCC" />
          <button
            className="menu-toggle"
            type="button"
            aria-label={menuOpen ? "Хаах" : "МСС дасгал ажил"}
            aria-expanded={menuOpen}
            aria-controls="site-navigation"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <Icon name={menuOpen ? "close" : "menu"} size={22} />
          </button>
        </div>
      </div>
    </header>
  );
}
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function NotFound() {
  return (
    <section className="empty-page">
      <span className="empty-page__icon">
        <Icon name="search" size={30} />
      </span>
      <h1>Тун удахгүй...</h1>
      <Link className="btn btn-primary" to="/">
        <Icon name="left" size={18} />
        Нүүр хуудас
      </Link>
    </section>
  );
}
export default function App() {
  const { pathname } = useLocation();
  const [showInfo, setShowInfo] = useState(false);
  const isHome = pathname === "/";
  const info = routeInfo(pathname);
  return (
    <div className="app-wrapper">
      <ScrollToTop />
      <SiteHeader onInfo={() => setShowInfo(true)} />
      <main
        id="main-content"
        className={`site-main ${isHome ? "site-main--home" : ""}`}
      >
        {!isHome && (
          <div className="breadcrumb">
            <Link to={info.parent}>
              <Icon name="left" size={17} />
              {info.label}
            </Link>
          </div>
        )}
        <Suspense fallback={<LoadingPage />}>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route
              path="/eshleluud"
              element={<ChapterListPage kind="eshleluud" />}
            />
            <Route path="/eshleluud/:num" element={<EshleluudPage />} />
            <Route path="/duruud" element={<ChapterListPage kind="duruud" />} />
            <Route path="/duruud/:num" element={<DuruudPage />} />
            <Route path="/buleg-taah" element={<BookListPage />} />
            <Route path="/buleg-taah/:book" element={<NomuudPage />} />
            <Route path="/tsag-uy" element={<TsagUyPage />} />
            <Route path="/tsag-uy/haaduud" element={<KingsPeriodExercise />} />
            <Route
              path="/tsag-uy/esh-uzuulegchid"
              element={<EshUzuulegchidExercise />}
            />
            <Route
              path="/tsag-uy/zahidal"
              element={<PersonOrPlaceExercise />}
            />
            <Route path="/bibleduruud" element={<BibleCharacters />} />
            <Route path="/crosswords" element={<CrosswordExercise />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      {/* <footer className="site-footer">
        <span>{APP_INFO.copyright}</span>
        <button type="button" onClick={() => setShowInfo(true)}>
          {APP_INFO.version} <Icon name="right" size={14} />
        </button>
      </footer> */}
      <AppInfo show={showInfo} onClose={() => setShowInfo(false)} />
    </div>
  );
}
